// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';
import { isiOSMobileTablet } from '@tcp/core/src/utils';
import colors from '@tcp/core/styles/themes/TCP/colors';

export default css`
  &.filter-checkbox-main {
    .checkBoxLabelAlign {
      margin: 10px 16px;
    }
    .disable-list-items {
      pointer-events: none;
    }
    .check-list {
      margin-left: 10px;
    }
    .CheckBox__input {
      width: 20px;
      height: 20px;
    }
    .CheckBox__input:checked:after {
      left: 7px;
      top: 0px;
      width: 6px;
      height: 15px;
    }
    .CheckBox__text {
      font-size: 14px;
    }
    .show-more-less {
      padding: 0;
      margin: auto 14px;
      min-height: auto;
    }
    .show-more-less-text {
      color: ${colors.BUTTON.BLUE.LEFT_FILTERS_BTN};
      background-color: #fff;
      text-decoration: underline;
    }
    .show-more-less:focus {
      background-color: #fff;
    }
    .limit-text {
      text-transform: capitalize;
      font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy3}px;
      font-family: Nunito;
    }
    .show-more-less-icon {
      margin-left: 4px;
      top: 1px;
      position: relative;
    }
    .checkbox-click {
      background-color: #fff;
      font-size: 14px;
      text-transform: capitalize;
      padding-bottom: 11px;
      min-height: auto;
    }
    .check-container {
      display: flex;
      text-align: left;
      width: 100%;
    }
    .check-box1 {
      border: 1px #929292 solid;
      color: #fff;
      border-radius: 2px;
      height: 16px;
      width: 16px;
    }
    .check-box1::after {
      transform: rotate(225deg);
      content: '';
      border-width: 2px 0px 0px 2px;
      border-top-style: solid;
      border-left-style: solid;
      border-top-color: rgb(255, 255, 255);
      border-left-color: rgb(255, 255, 255);
      border-image: initial;
      font-size: 12px;
      border-right-style: initial;
      border-right-color: initial;
      border-bottom-style: initial;
      border-bottom-color: initial;
      position: absolute;
      left: ${isiOSMobileTablet() ? '18.5px' : '11.5px'};
      top: 3px;
      width: 5px;
      height: 9.5px;
    }
    .check-label {
      margin-left: 14px;
      flex: 9;
      font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy3}px;
      font-family: Nunito;
    }
    .check-background {
      background-color: #000;
    }
    .check-color {
      color: #000;
    }
    .highlight {
      font-weight: 700;
    }
  }
`;
